import get from "lodash.get";

import { widgetConfig } from "../config";

function logApiKeyError(error) {
	switch (get(error, "response.data.key", undefined)) {
		case "AUTHORIZATION.CORS_DOMAIN":
			console.error(`${widgetConfig.loggingName}: ${widgetConfig.errors.corsError}`);
			break;
		case "AUTHORIZATION.NO_ACTIVE_SUBSCRIPTION":
			console.error(`${widgetConfig.loggingName}: ${widgetConfig.errors.noActiveSubscription}`);
			break;
		default:
			console.error(`${widgetConfig.loggingName}: ${widgetConfig.errors.apiKeyInvalid}`);
	}
}

let logHistory = [];

export default {
	logApiKeyError,
	warn(...messages) {
		console.warn(...messages);
		logHistory.push(messages);
	},
	error(...messages) {
		console.error(...messages);
		logHistory.push(messages);
	},
	getLogs: () => logHistory,
}
